/*  ========================================================================
    # Pages - Submit
    ========================================================================  */

// Dependencies
import Close from '@images/svg/ui/close.svg';
import { motion } from 'framer-motion';
import React, { cloneElement, useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import FormNavigation from '../components/FormNavigation';
import FormProgress from '../components/FormProgress';
import SubmissionStep from '../components/SubmissionStep';
import { SubmissionSteps } from '../helpers/submissionConfig';
import { SubmissionContext } from '../utils/SubmissionContextProvider';
import SendSubmission from '../components/SendSubmission';

const Submit = () => {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState('forward');
  const submissionContext = useContext(SubmissionContext);
  const [submitting, setSubmitting] = useState(false);

  const confirmExit = event => {
    if (
      !confirm(
        'Möchtest Du zurück zur Startseite wechseln? Deine Eingaben werden vorübergehend gespeichert.'
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  };

  const canGoBack = index > 0;
  const canGoNext = (forIndex = index) => {
    return (
      forIndex <= SubmissionSteps.length - 1 &&
      SubmissionSteps[forIndex].isValid(submissionContext) === true
    );
  };
  const handleGoBack = () => {
    if (index > 0) {
      setDirection('reverse');
      setIndex(index - 1);
    }
  };
  const handleGoNext = () => {
    if (canGoNext) {
      setDirection('forward');
      setIndex(index + 1);
    }
  };

  const handleError = message => {
    setSubmitting(false);
    alert(message);
  };

  return (
    <>
      <Helmet>
        <title>Idee einreichen – Raiffeisen-Förderpreis 2025</title>
      </Helmet>

      <motion.main
        className='p-submit'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <SendSubmission submitting={submitting} onError={handleError} />
        <FormNavigation index={index} />
        <div className='p-submit__steps-container'>
          {SubmissionSteps.map((step, i) => (
            <SubmissionStep
              canGoNext={canGoNext(i)}
              direction={direction}
              handleGoNext={handleGoNext}
              displayOffset={i - index}
              index={i}
              key={i}
              buttonLabel={i === SubmissionSteps.length - 1 ? 'Idee einreichen' : 'Okay'}
              onSendSubmission={
                i === SubmissionSteps.length - 1 ? () => setSubmitting(true) : undefined
              }
            >
              {cloneElement(step.view, { currentStep: index === i })}
            </SubmissionStep>
          ))}
        </div>
        <div className='p-submit__bottom-bar'>
          <div className='p-submit__container'>
            <div className='p-submit__bottom-bar-wrapper'>
              <Link className='p-submit__back' to='/' onClick={confirmExit}>
                <Close />
              </Link>
              <FormProgress
                {...{
                  index,
                  canGoBack,
                  canGoNext: canGoNext() && index < SubmissionSteps.length - 1,
                  handleGoBack,
                  handleGoNext
                }}
              />
            </div>
          </div>
        </div>
      </motion.main>
    </>
  );
};

export default Submit;
